import { render, staticRenderFns } from "./EditPessoasexoPage.vue?vue&type=template&id=5559b161&"
import script from "./EditPessoasexoPage.vue?vue&type=script&lang=js&"
export * from "./EditPessoasexoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports